<template>
    <div class="no-results">
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'no-results',
}

</script>
<style lang="scss" scoped>
    .no-results {
        text-align: center;
        height: 10rem;
        padding: var(--padding-x2);
        clear: both;
        display: block;
    }
</style>